<template>
  <div class="home">
    <Header />
    <Hero />

    <section>
      <div class="container mt-5">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="box live p-4">
              <img src="@/assets/images/live.svg" alt="Canlı Yayın" />
              <h2 class="title red text-center">Canlı Yayın</h2>
              <router-link
                to="/live/gS0tFd1I4E08y1UJNAm4"
                class="btn btn-danger btn-md mt-2"
                >CANLI İZLE</router-link
              >
              <!--
              <span>SIRADAKİ OTURUM</span>
              <h2 class="mt-4">
                MVP, Nasıl Tanı Konulur?<br />3D EKO Ne Katkı Sağlar?
              </h2>
              <p class="pt-3 pb-3">
                Dr. Hani Mahmuod Elsayed<br />
                <span
                  >Al-Nas Hospital, Shubra Al-Kheimah, Al-Qalyubia Kahire</span
                >
              </p>
              <router-link to="/live" class="btn btn-info btn-md mt-2"
                >CANLI İZLE</router-link
              >
              -->
            </div>
          </div>

          <div class="col-xs-12 col-md-6">
            <div class="box p-4">
              <h2 class="title blue text-center">Katılım Sertifikası</h2>
              <p style="text-align: center">
                Katılım sertifikalarınızı aşağıdaki linke tıklayarak alabilirsiniz.
              </p>

              <router-link class="btn btn-info btn-md" to="/certificate"
                >SERTİFİKA İÇİN TIKLAYIN</router-link
              >
            </div>
          </div>
          <div class="col-md-12">
            <div class="box">
              <img
                src="@/assets/images/ad_960x360.jpg"
                class="img-fluid"
                alt="Rader Dijital Güz Atölyesi"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <Sponsors />
    <Agenda />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Hero from '@/components/Hero.vue';
import Agenda from '@/components/Agenda.vue';
import Sponsors from '@/components/Sponsors.vue';
import { mapActions } from 'vuex';

export default {
  name: 'Home',
  components: {
    Header,
    Agenda,
    Sponsors,
    Hero,
  },
  data() {
    return {
      isReady: false,
    };
  },
  methods: {
    ...mapActions({
      setCurrent: 'event/setCurrent',
      getEvent: 'event/get',
    }),
    tabClick() {
      console.log('tabClick');
    },
    goBack() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  &.live {
    h2 {
      color: #dc3545;
    }
  }
}
</style>
